import $ from 'jquery';
import constants from 'Constants.js';
import BaseTableView from 'properties/BaseTableView.js'
import Template from 'behaviors/properties/main/show-report.ejs';
import selectFormOrReportModalView from 'common-views/SelectFormOrReportModalView.js';
import eventBus from 'EventBus';
import util from 'util/Util.js';
//=====================================================================
//
// An instance of this view represents a show report.
//
// Casey Justus, June 2, 2016
//
//=====================================================================

class MainShowReportView extends BaseTableView {

    itemNew(){
        var gridData = this.model.get('gridData');
        var newRow = {
            'source':'' ,
            'formula': ''
        };
        $(constants.PROP_MAIN_TABLE).addRowData((gridData.length + 1), newRow);

        gridData.push(newRow);
        this.model.set('gridData', gridData);
    }  
    
    onCellSelect(rowid, iCol, cellcontent,e){
        //console.log(rowid, iCol, cellcontent,e);  
        if (iCol === 1){
            console.log('launch modal for ' + rowid);
        }      
    }

    initialize( opts ) {
 
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE;

        this.events = {
            'change input[type=checkbox]'   : 'updateCheckAttributes',
            'change input[type=text]'       : 'updateAttributes',
            'blur input[type=text]'         : 'lostFocus',
            'focus input[type=text]'        : 'getFocus',
            "click .itemNew"                : "itemNew",
            "click .itemRemove"             : "itemRemove",
            "click #selectReport"             : "showSelectModal"
        };
        //this.listenTo(this.model, 'change', this.render); 

        return this;
    }

    showSelectModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';
        var sfModal = new selectFormOrReportModalView({model: this.model, mode: 'report'});
        sfModal.render().then((selectedField)=>{
            this.model.set('formOrReport', selectedField.name);
            this.render();
        }).catch(err => console.log(err));
    }
    
   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    updateCheckAttributes(ev) {
        console.log('updateCheckAttributes');
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        var newValue = "";
        if (propVal) {
            newValue = "checked";
        }
        this.model.set( propName, newValue );
    }

}

export default MainShowReportView;
